<template lang="html">

  <section class="politica-de-privacidad">
    <div class="legal" v-html="texto"></div>
  </section>

</template>

<script lang="js">

  import axios from 'axios';

  export default {
    name: 'politica-de-privacidad',
    props: [],
    mounted() {
      this.setData();
    },
    data() {
      return {
        texto : ''
      }
    },
    methods: {
      setData() {
        const id_contenedor = 'texto_legal';

        let params;

        if (window.location.search) {
          var url = new URLSearchParams(window.location.search);
          params = Object.fromEntries(url.entries());
        } else {
          params = {
            "area_mkt_desc": "Pascual Corporativo",
            "texto_extendido": "1",
            "clave": "PP - CALIDAD PASCUAL SUSCRIPCION WEB NEWSLETTER DOUBLEDOT"
          }
        }
        const apiURL = "https://apin-datahub-desa-001.azure-api.net/azfun-datahub-desa-001"

        let texto_legal_url = (params.texto_extendido !== "2") ? `${apiURL}/texto-legal-extendido/${params.clave}?area_mkt_desc=${params.area_mkt_desc}` : `${apiURL}/texto-legal-extra/${params.clave}?area_mkt_desc=${params.area_mkt_desc}`
        
        axios.get(texto_legal_url).then(result => {

            this.texto = result.data.Texto;


          });

      }
    },
    computed: {}
  }
</script>

<style scoped lang="scss">
  .politica-de-privacidad {}
</style>


// WEBPACK FOOTER //
// src/components/views/politica-de-privacidad.vue